var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-facebook"),React.createElement("path",{"d":"M21.33 30V19.215h3.638l.545-4.225h-4.184v-2.697c0-1.223.34-2.057 2.094-2.057h2.237v-3.78c-.387-.05-1.715-.166-3.26-.166-3.225 0-5.434 1.97-5.434 5.585v3.115h-3.648v4.225h3.648V30H3.546A1.545 1.545 0 0 1 2 28.455V3.545C2 2.692 2.692 2 3.545 2h24.91C29.308 2 30 2.692 30 3.545v24.91c0 .853-.692 1.545-1.545 1.545h-7.126z","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

IconFacebook.defaultProps = {"id":"icon-facebook","width":"24px","height":"24px","viewBox":"0 0 32 32"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
